import { render, staticRenderFns } from "./destroyImg.vue?vue&type=template&id=3d90a81e&scoped=true&"
import script from "./destroyImg.vue?vue&type=script&lang=js&"
export * from "./destroyImg.vue?vue&type=script&lang=js&"
import style0 from "./destroyImg.vue?vue&type=style&index=0&id=3d90a81e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d90a81e",
  null
  
)

export default component.exports